import axios from 'axios'

const state = {
    active: null,
    list: [],
}

const getters = {
    list: state => state.list,
}

const actions = {
    async createInvitation({ commit }, data) {
        const response = await axios.post(`${process.env.VUE_APP_NODE_API_HOST}/invitations`, data.invitationData)

        commit('CREATE_INVITATION', response.data.invitation)

        return response.data.data
    },

    async updateInvitation({ commit }, data) {
        const response = await axios.put(`${process.env.VUE_APP_NODE_API_HOST}/invitations/${data.id}`, data.invitationData)

        return response.data.data
    },

    async getInvitations({ commit }) {
        const response = await axios.get(process.env.VUE_APP_NODE_API_HOST + '/invitations')
        commit('SET_INVITATIONS', response.data.data)

        return response.data.data
    },

    async fetchInvitation({ commit }, id) {
        const response = await axios.get(`${process.env.VUE_APP_NODE_API_HOST}/invitations/${id}`)
        return response.data.data
    }
}

const mutations = {
    SET_INVITATIONS(state, list) {
        state.list = list
    },
    SET_INVITATION(state, active) {
        state.active = active
    },
    CREATE_INVITATION(state, invitation) {
        state.list.push(invitation)
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
